import { atom } from "recoil";

export const HeaderAtom = atom({
    key: 'HeaderAtom',
    default: 0,
});

